/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/**
 * Initialize swiper slider by selector.
 *
 * @param selector
 * @param options
 * @returns {*}
 */
function initSwiperSlider(selector, options) {
  options = options || {
    slidesPerView: 2,
    spaceBetween: 11,
    speed: 1300,
    navigation: {
      nextEl: ".btn-next",
      prevEl: ".btn-prev",
    },
    breakpoints: {
      768: {
        spaceBetween: 30,
        slidesPerView: 3,
      },
      992: {
        spaceBetween: 30,
        slidesPerView: 4,
      },
      1200: {
        spaceBetween: 20,
        slidesPerView: 5,
      }
    },
  };

  return new Swiper(selector, options);
}

function setupKlaviyoPopupTriggers() {
  window._klOnsite = window._klOnsite || [];

  const name = 'klaviyoOpenPopup';
  const triggerAnchors = document.querySelectorAll('[href*="#'+ name +'="]');
  triggerAnchors.forEach(function(anchor) {
    const regex = new RegExp('#('+ name +')=(\\w+)');
    const matches = anchor.href.match(regex);
    if (!matches || matches.length < 3) {
      return;
    }

    anchor.addEventListener('click', function(e) {
      e.preventDefault();

      window._klOnsite.push(['openForm', matches[2]]);
    });
  });
}
setupKlaviyoPopupTriggers();
